import React from 'react';
import Grid from '@rezdy/components/Grid';
import Card from './Layout/Card';
import TextStyle from '@rezdy/components/TextStyle';
import AvatarCard from '../AvatarCard';

interface IState {
    cardPhoto: string;
    description: string;
    avatarCard: {
        avatar: string;
        company: string;
        name: string;
        rating: number;
    };
}

export class SignUpCard extends React.PureComponent<{}, IState> {
    state = {
        cardPhoto: '/img/signup-img.jpg',
        // eslint-disable-next-line prettier/prettier
        description:
            'Rezdy saves us a significant amount of time which lets us focus on sailing, which is the main thing for us.',
        avatarCard: {
            avatar: '/img/signup-avatar.jpg',
            company: 'Owner, Manly Sailing',
            name: 'Finn Irvine',
            rating: 6,
        },
    };

    render = () => {
        return (
            <Card photo={this.state.cardPhoto}>
                <Grid.Container rowGap>
                    <Grid.Cell>
                        <TextStyle>{this.state.description}</TextStyle>
                    </Grid.Cell>
                    <Grid.Cell>
                        <AvatarCard {...this.state.avatarCard} />
                    </Grid.Cell>
                </Grid.Container>
            </Card>
        );
    };
}
